export interface BaseModel {
  readonly id: number;
  readonly createdAt: Date;
  readonly updatedAt: Date;
  archived: boolean;
}

export enum ActionStatus {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
